import React, { useState, useEffect } from "react";
import {
  List,
  ListItemText,
  ListItemIcon,
  AppBar,
  Box,
  Toolbar,
  Typography,
  CssBaseline,
  Drawer,
  IconButton,
  ListItemButton,
  Collapse,
  Avatar,
  BottomNavigation,
  Paper,
  Tooltip,
} from "@mui/material";

import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SellIcon from "@mui/icons-material/Sell";
// import SettingsIcon from "@mui/icons-material/Settings";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { alpha, styled } from "@mui/material/styles";
import style from "../styles/sellerHeader";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
//backend
import { useSelector } from "react-redux";

import { withRouter, useLocation } from "react-router-dom";

import logo from "../assets/images/dc.jpg";
import { auth } from "../utils/firebase";


const drawerWidth = 280;
const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const shapeStyles = {
  width: 5,
  height: 5,
  bgcolor: "gray",
  borderRadius: "50%",
};
const shapeStylesSelected = {
  width: 7,
  height: 7,
  bgcolor: "primary.main",
  borderRadius: "50%",
};

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));
const AccountStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: "#EDEFF2",
}));

const Sidebar = (props) => {
  const userData = useSelector((state) => state.user);

  const { history } = props;
  const location = useLocation();

  //button
  const buttonLogout = () => {
    auth.signOut();
  };

  const [selectedIndex, setSelectedIndex] = useState(
    location.pathname === "/dashboard"
      ? 1
      : location.pathname === "/listuser"
      ? 2
      : location.pathname === "/createuser"
      ? 2
      : location.pathname === "/edituser"
      ? 2
      : location.pathname === "/allproduct"
      ? 3
      : location.pathname === "/addproduct"
      ? 3
      : location.pathname === "/order"
      ? 4
      : location.pathname === "/newsblogs"
      ? 5
      : location.pathname === "/allnewsblogs"
      ? 5
      : location.pathname === "/addnewsblogs"
      ? 5
      : location.pathname === "/editnewsblogs"
      ? 5
      : location.pathname === "/finance"
      ? 6
      : location.pathname === "/settings"
      ? 7
      : 0
  );
  const [subSelectedIndex, setSubSelectedIndex] = useState(
    location.pathname === "/allproduct"
      ? 1
      : location.pathname === "/addproduct"
      ? 2
      : location.pathname === "/editproduct"
      ? 3
      : location.pathname === "/addmotor"
      ? 4
      : 0
  );
  const [subSelectedIndexUser, setSubSelectedIndexUser] = useState(
    location.pathname === "/listuser"
      ? 1
      : location.pathname === "/createuser"
      ? 2
      : location.pathname === "/edituser"
      ? 3
      : 0
  );
  const [subSelectedIndexNewsBlogs, setSubSelectedIndexNewsBlogs] = useState(
    location.pathname === "/allnewsblogs"
      ? 1
      : location.pathname === "/addnewsblogs"
      ? 2
      : location.pathname === "/editnewsblogs"
      ? 3
      : 0
  );
  const [area, setArea] = useState("dashboard");
  const [mobileOpen, setMobileOpen] = React.useState(false);

  console.log(area);
  // console.clear();

  //NestedList
  const [open1, setOpen1] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [openNewsBlogs, setOpenNewsBlogs] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // dashboard
  const handleListItemClick = (event, index, area) => {
    history.push("/dashboard");
    setSubSelectedIndex(0);
    setSubSelectedIndexUser(0);
    setOpenUser(false);
    setOpen1(false);
    setOpenNewsBlogs(false);
    setSelectedIndex(index);
    setArea(area);
  };

  // start user
  const handleListItemClickUser = (event, index, area) => {
    if (location.pathname === "/listuser") {
      setSubSelectedIndexUser(1);
    } else if (location.pathname === "/createuser") {
      setSubSelectedIndexUser(2);
    } else if (location.pathname === "/edituser") {
      setSubSelectedIndexUser(3);
    } else {
      setSubSelectedIndexUser(0);
    }
    setSelectedIndex(index);
    setOpenUser(!openUser);
    setOpen1(false);
    setOpenNewsBlogs(false);
  };

  const handleListItemClickUserList = (event, index, area) => {
    history.push("/listuser");
    setSubSelectedIndexUser(index);
    setArea(area);
  };

  const handleListItemClickUserCreate = (event, index, area) => {
    history.push("/createuser");
    setSubSelectedIndexUser(index);
    setArea(area);
  };

  const handleListItemClickUserEdit = (event, index, area) => {
    history.push("/edituser");
    setSubSelectedIndexUser(index);
    setArea(area);
  };

  // end user

  const handleListItemClick2 = (event, index, area) => {
    if (location.pathname === "/allproduct") {
      setSubSelectedIndex(1);
    } else if (location.pathname === "/addproduct") {
      setSubSelectedIndex(2);
    } else if (location.pathname === "/editproduct") {
      setSubSelectedIndex(3);
    } else {
      setSubSelectedIndex(0);
    }

    setSelectedIndex(index);
    setOpen1(!open1);
    setOpenUser(false);
    setOpenNewsBlogs(false);
  };
  const handleListItemClick1 = (event, index, area) => {
    history.push(area);
    setOpen1(false);
    setSelectedIndex(index);
    setOpenUser(false);
    setArea(area);
  };

  const handleListItemClick11 = (event, index, area) => {
    history.push("/allproduct");
    setSubSelectedIndex(index);
    setArea(area);
  };

  const handleListItemClick12 = (event, index, area) => {
    history.push("/addproduct");
    setSubSelectedIndex(index);
    setArea(area);
  };

  const handleListItemClick13 = (event, index, area) => {
    history.push("/editproduct");
    setSubSelectedIndex(index);
    setArea(area);
  };
  const handleListItemClick14 = (event, index, area) => {
    history.push("/addmotor");
    setSubSelectedIndex(index);
    setArea(area);
  };

  //news and blogs
  const handleListItemClickNewsBlogs = (event, index, area) => {
    if (location.pathname === "/allnewsblogs") {
      setSubSelectedIndexNewsBlogs(1);
    } else if (location.pathname === "/addnewsblogs") {
      setSubSelectedIndexNewsBlogs(2);
    } else if (location.pathname === "/editnewsblogs") {
      setSubSelectedIndexNewsBlogs(3);
    } else {
      setSubSelectedIndexNewsBlogs(0);
    }

    setSelectedIndex(index);
    setOpenNewsBlogs(!openNewsBlogs);
    setOpenUser(false);
    setOpen1(false);
  };
  // const handleListItemClickNewsBlogs1 = (event, index, area) => {
  //   history.push(area);
  //   setOpen1(false);
  //   setSelectedIndex(index);
  //   setOpenUser(false);
  //   setArea(area);
  // };

  const handleListItemClickNewsBlogsAll = (event, index, area) => {
    history.push("/allnewsblogs");
    setSubSelectedIndexNewsBlogs(index);
    setArea(area);
  };

  const handleListItemClickNewsBlogsAdd = (event, index, area) => {
    history.push("/addnewsblogs");
    setSubSelectedIndexNewsBlogs(index);
    setArea(area);
  };

  const handleListItemClickNewsBlogsEdit = (event, index, area) => {
    history.push("/editnewsblogs");
    setSubSelectedIndexNewsBlogs(index);
    setArea(area);
  };

  const container = "";

  const drawer = (
    <Box sx={{ mb: 5 }}>
      <Toolbar>
        <Box sx={{ py: 3, display: "inline-flex" }}>
          <Img src={logo} sx={{ height: 30 }} />
        </Box>

        {/*          
          <ListItemText>
            <Typography sx={{ fontSize: 10, fontWeight: 500 }}>
              Agrishop
            </Typography>
            <Typography sx={{ fontSize: 8 }}>Bit</Typography>
          </ListItemText> */}
      </Toolbar>
      <Box sx={{ mb: 2, mx: 2.5, mt: 1 }}>
        <AccountStyle>
          <Avatar src={userData.currentUserData[0].Image} alt="photoURL" />
          <Box sx={{ ml: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{ color: "text.primary", fontWeight: 700 }}
            >
              {userData.currentUserData[0].UserName}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {userData.currentUserData[0].UserType}
            </Typography>
          </Box>
        </AccountStyle>
      </Box>

      <List>
        <Typography sx={{ fontSize: 12, fontWeight: "bold", p: 1.5, ml: 3 }}>
          GENERAL
        </Typography>
        <ListItemButton
          selected={selectedIndex === 1}
          sx={style.listItemContainer}
          onClick={(event) => handleListItemClick(event, 1, "dashboard")}
        >
          <ListItemIcon>
            <DashboardIcon
              sx={{ fontSize: 20 }}
              color={selectedIndex === 1 ? "primary" : "none"}
            />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: selectedIndex === 1 ? "bold" : "none",
              }}
              color={selectedIndex === 1 ? "primary" : "none"}
            >
              Dashboard
            </Typography>
          </ListItemText>
        </ListItemButton>

        <Typography sx={{ fontSize: 12, fontWeight: "bold", p: 1.5, ml: 3 }}>
          MANAGEMENT
        </Typography>

        {/* User */}
        <ListItemButton
          selected={selectedIndex === 2}
          sx={style.listItemContainer}
          onClick={(event) => handleListItemClickUser(event, 2, "user")}
        >
          <ListItemIcon>
            <PersonRoundedIcon
              sx={{ fontSize: 20 }}
              color={selectedIndex === 2 ? "primary" : "none"}
            />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: selectedIndex === 2 ? "bold" : "none",
              }}
              color={selectedIndex === 2 ? "primary" : "none"}
            >
              User
            </Typography>
          </ListItemText>
          {openUser ? (
            <ExpandMore
              sx={{ fontSize: 20 }}
              color={selectedIndex === 2 ? "primary" : "gray"}
            />
          ) : (
            <ChevronRightOutlinedIcon sx={{ fontSize: 20 }} />
          )}
        </ListItemButton>

        <Collapse in={openUser} timeout="auto" unmountOnExit>
          <List disablePadding>
            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) =>
                handleListItemClickUserList(event, 1, "listuser")
              }
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndexUser === 1
                      ? shapeStylesSelected
                      : shapeStyles
                  }
                />
              </ListItemIcon>
              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight: subSelectedIndexUser === 1 ? "bold" : "none",
                  }}
                >
                  List
                </Typography>
              </ListItemText>
            </ListItemButton>

            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) =>
                handleListItemClickUserCreate(event, 2, "createuser")
              }
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndexUser === 2
                      ? shapeStylesSelected
                      : shapeStyles
                  }
                />
              </ListItemIcon>

              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight: subSelectedIndexUser === 2 ? "bold" : "none",
                  }}
                >
                  Create
                </Typography>
              </ListItemText>
            </ListItemButton>

            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) =>
                handleListItemClickUserEdit(event, 3, "editeuser")
              }
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndexUser === 3
                      ? shapeStylesSelected
                      : shapeStyles
                  }
                />
              </ListItemIcon>

              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight: subSelectedIndexUser === 3 ? "bold" : "none",
                  }}
                >
                  Edit
                </Typography>
              </ListItemText>
            </ListItemButton>
          </List>
        </Collapse>

        {/* Product */}
        <ListItemButton
          selected={selectedIndex === 3}
          sx={style.listItemContainer}
          onClick={(event) => handleListItemClick2(event, 3, "product")}
        >
          <ListItemIcon>
            <SellIcon
              sx={{ fontSize: 20 }}
              color={selectedIndex === 3 ? "primary" : "none"}
            />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: selectedIndex === 3 ? "bold" : "none",
              }}
              color={selectedIndex === 3 ? "primary" : "none"}
            >
              Product
            </Typography>
          </ListItemText>
          {open1 ? (
            <ExpandMore
              sx={{ fontSize: 20 }}
              color={selectedIndex === 3 ? "primary" : "gray"}
            />
          ) : (
            <ChevronRightOutlinedIcon sx={{ fontSize: 20 }} />
          )}
        </ListItemButton>

        <Collapse in={open1} timeout="auto" unmountOnExit>
          <List disablePadding>
            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) => handleListItemClick11(event, 1, "allproduct")}
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndex === 1 ? shapeStylesSelected : shapeStyles
                  }
                />
              </ListItemIcon>
              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight: subSelectedIndex === 1 ? "bold" : "none",
                  }}
                >
                  All Product
                </Typography>
              </ListItemText>
            </ListItemButton>

            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) => handleListItemClick12(event, 2, "addproduct")}
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndex === 2 ? shapeStylesSelected : shapeStyles
                  }
                />
              </ListItemIcon>

              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight: subSelectedIndex === 2 ? "bold" : "none",
                  }}
                >
                  Add Product
                </Typography>
              </ListItemText>
            </ListItemButton>

            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) =>
                handleListItemClick13(event, 3, "editproduct")
              }
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndex === 3 ? shapeStylesSelected : shapeStyles
                  }
                />
              </ListItemIcon>

              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight: subSelectedIndex === 3 ? "bold" : "none",
                  }}
                >
                  Edit Product
                </Typography>
              </ListItemText>
            </ListItemButton>

            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) => handleListItemClick14(event, 4, "addmotor")}
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndex === 4 ? shapeStylesSelected : shapeStyles
                  }
                />
              </ListItemIcon>

              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight: subSelectedIndex === 4 ? "bold" : "none",
                  }}
                >
                  Add Motor
                </Typography>
              </ListItemText>
            </ListItemButton>
          </List>
        </Collapse>

        {/* Order */}
        <ListItemButton
          selected={selectedIndex === 4}
          sx={style.listItemContainer}
          onClick={(event) => handleListItemClick1(event, 4, "order")}
        >
          <ListItemIcon>
            <DescriptionRoundedIcon
              sx={{ fontSize: 20 }}
              color={selectedIndex === 4 ? "primary" : "none"}
            />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: selectedIndex === 4 ? "bold" : "none",
              }}
              color={selectedIndex === 4 ? "primary" : "none"}
            >
              Order
            </Typography>
          </ListItemText>
        </ListItemButton>

        {/* News & Blogs */}
        <ListItemButton
          selected={selectedIndex === 5}
          sx={style.listItemContainer}
          onClick={(event) =>
            handleListItemClickNewsBlogs(event, 5, "newsblogs")
          }
        >
          <ListItemIcon>
            <NewspaperOutlinedIcon
              sx={{ fontSize: 20 }}
              color={selectedIndex === 5 ? "primary" : "none"}
            />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: selectedIndex === 5 ? "bold" : "none",
              }}
              color={selectedIndex === 5 ? "primary" : "none"}
            >
              News {"&"} Blogs
            </Typography>
          </ListItemText>
          {openNewsBlogs ? (
            <ExpandMore
              sx={{ fontSize: 20 }}
              color={selectedIndex === 5 ? "primary" : "gray"}
            />
          ) : (
            <ChevronRightOutlinedIcon sx={{ fontSize: 20 }} />
          )}
        </ListItemButton>

        <Collapse in={openNewsBlogs} timeout="auto" unmountOnExit>
          <List disablePadding>
            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) =>
                handleListItemClickNewsBlogsAll(event, 1, "allnewsblogs")
              }
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndexNewsBlogs === 1
                      ? shapeStylesSelected
                      : shapeStyles
                  }
                />
              </ListItemIcon>
              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight:
                      subSelectedIndexNewsBlogs === 1 ? "bold" : "none",
                  }}
                >
                  List
                </Typography>
              </ListItemText>
            </ListItemButton>

            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) =>
                handleListItemClickNewsBlogsAdd(event, 2, "addnewsblogs")
              }
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndexNewsBlogs === 2
                      ? shapeStylesSelected
                      : shapeStyles
                  }
                />
              </ListItemIcon>

              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight:
                      subSelectedIndexNewsBlogs === 2 ? "bold" : "none",
                  }}
                >
                  Create
                </Typography>
              </ListItemText>
            </ListItemButton>

            <ListItemButton
              sx={style.subListItemContainer}
              onClick={(event) =>
                handleListItemClickNewsBlogsEdit(event, 3, "editnewsblogs")
              }
            >
              <ListItemIcon>
                <Box
                  component="span"
                  sx={
                    subSelectedIndexNewsBlogs === 3
                      ? shapeStylesSelected
                      : shapeStyles
                  }
                />
              </ListItemIcon>

              <ListItemText>
                <Typography
                  sx={{
                    fontSize: 14,
                    ml: -1,
                    fontWeight:
                      subSelectedIndexNewsBlogs === 3 ? "bold" : "none",
                  }}
                >
                  Edit
                </Typography>
              </ListItemText>
            </ListItemButton>
          </List>
        </Collapse>

        {/* Finance */}
        <ListItemButton
          selected={selectedIndex === 6}
          sx={style.listItemContainer}
          onClick={(event) => handleListItemClick1(event, 6, "finance")}
        >
          <ListItemIcon>
            <AccountBalanceWalletIcon
              sx={{ fontSize: 20 }}
              color={selectedIndex === 6 ? "primary" : "none"}
            />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: selectedIndex === 6 ? "bold" : "none",
              }}
              color={selectedIndex === 6 ? "primary" : "none"}
            >
              Finance
            </Typography>
          </ListItemText>
        </ListItemButton>

        {/* Settings
        <ListItemButton
          selected={selectedIndex === 7}
          sx={style.listItemContainer}
          onClick={(event) => handleListItemClick1(event, 7, "settings")}
        >
          <ListItemIcon>
            <SettingsIcon
              sx={{ fontSize: 20 }}
              color={selectedIndex === 7 ? "primary" : "none"}
            />
          </ListItemIcon>
          <ListItemText>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: selectedIndex === 7 ? "bold" : "none",
              }}
              color={selectedIndex === 7 ? "primary" : "none"}
            >
              Settings
            </Typography>
          </ListItemText>
        </ListItemButton> */}
      </List>
      {/* <Divider /> */}

      <Paper
        sx={{
          position: "fixed",
          bottom: 0,
          width: 279,
          boxShadow: "0px -1px 0px 0px rgba(0,0,0,0.2), 0px 1px 0px 0px rgba(0,0,0,0.14), 0px 2px 0px 0px rgba(0,0,0,0.12)",
          // borderTopStyle: "dashed",
          // borderTopWidth: 1,
          // borderTopColor: "gray",
          // borderRightStyle: "dashed",
          // borderRightWidth: .5,
          // borderRightColor: "grey",
        }}
      >
        <BottomNavigation showLabels>
          <Tooltip title="Logout" placement="bottom">
            <IconButton onClick={buttonLogout}>
              <PowerSettingsNewIcon color="primary" />
            </IconButton>
          </Tooltip>
        </BottomNavigation>
      </Paper>
    </Box>
  );

  useEffect(() => {
    if (
      location.pathname === "/addproduct" ||
      location.pathname === "/allproduct" ||
      location.pathname === "/editproduct" ||
      location.pathname === "/addmotor"
    ) {
      setOpen1(true);
    } else if (
      location.pathname === "/listuser" ||
      location.pathname === "/createuser" ||
      location.pathname === "/edituser"
    ) {
      setOpenUser(true);
    } else if (
      location.pathname === "/allnewsblogs" ||
      location.pathname === "/addnewsblogs" ||
      location.pathname === "/editnewsblogs"
    ) {
      setOpenNewsBlogs(true);
    } else {
    }
  }, [location.pathname]);

  return (
    // <Drawer variant="permanent" sx={{ width: "160px", "& .MuiDrawer-paper": {
    //   boxSizing: "border-box",
    //   borderRightStyle: 'dashed'
    // }, }}>
    //   <List>
    //     {itemslist.map((item, index) => {
    //       const { text, icon, onclick } = item;
    //       return (
    //         <ListItem button key={text} onClick={onclick}>
    //           <ListItemIcon>{icon}</ListItemIcon>
    //           <ListItemText primary={text} />
    //         </ListItem>
    //       );
    //     })}
    //   </List>
    // </Drawer>

    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <RootStyle>
        <ToolbarStyle>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { sm: "none" } }}
          >
            <MenuIcon color="primary" />
          </IconButton>
          {/* <Typography color="textPrimary">Seller</Typography> */}
          <Box sx={{ flexGrow: 1 }} />

          {/* <AccountMenu /> */}
        </ToolbarStyle>
      </RootStyle>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderRightStyle: "dashed",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

export default withRouter(Sidebar);
